export enum PanelFormFields {
  title = 'title',
  headerColor = 'headerColor',
  type = 'type',
}
